import { all, put, select, takeEvery } from 'redux-saga/effects';
import * as Actions from '../creativeMapping/actions';
import constants from '../../../../helpers/constant';
import { setCreativeSDOStatus, setCreativeSDOs, Status } from './actions';
import { getMentionsStructuredData } from '../../../../components/Watchlist/api';
import { showToast } from '../notification';

function * loadCreativeSDOs() {
  yield put(setCreativeSDOStatus(Status.LOADING));
  const config = yield select(state => state.config);
  const fetchResults = yield getMentionsStructuredData(config.urlApi, config.playoutSdoTableName || 'sdo_station_pl_1_5_p_6_gaixjxp');

  if (fetchResults && !fetchResults.error) {
    yield put(setCreativeSDOs([...fetchResults]));
  } else {
    yield put(setCreativeSDOStatus(Status.ERROR));
    yield put(showToast({
      message: 'Error loading Creative SDO List',
      action: 'Dismiss',
      type: constants.FAILED
    }));
  }
}

export default function * creativeMapping() {
  yield all([
    takeEvery(Actions.ActionType.LOAD_CREATIVE_SDOS, loadCreativeSDOs)
  ]);
};
